/* assets/cm-cart-upsell.js
   Maneja el upsell del cart drawer (snippet cart-analog-upsell.liquid).
   Delegación en document porque el drawer re-renderiza por innerHTML (los
   listeners inline no sobreviven). Tras añadir, dispara cart-drawer:refresh
   para que el server re-renderice y los botones desaparezcan solos. */
(function () {
  var WORKER = 'https://steep-bush-5027.santiclavijo5.workers.dev/generate';

  function refresh() {
    try { document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh')); } catch (e) {}
  }
  function busy(el, on) { if (el) el.classList.toggle('cau-busy', !!on); }

  function addItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var kit = t.closest ? t.closest('.js-cau-kit') : null;
    var war = t.closest ? t.closest('.js-cau-warranty') : null;

    if (kit) {
      e.preventDefault();
      busy(kit, true);
      addItems([{ id: parseInt(kit.getAttribute('data-variant'), 10), quantity: 1 }])
        .then(refresh)
        .catch(function () { busy(kit, false); });
      return;
    }

    if (war) {
      e.preventDefault();
      busy(war, true);
      var box = war.closest('.cau');
      var custEmail = war.getAttribute('data-cust-email') || (box && box.getAttribute('data-cust-email')) || null;
      var custId = war.getAttribute('data-cust-id') || (box && box.getAttribute('data-cust-id')) || null;
      var payload = {
        productPrice: parseInt(war.getAttribute('data-price'), 10),
        productId: parseInt(war.getAttribute('data-variant'), 10) || undefined,
        productTitle: war.getAttribute('data-title'),
        productHandle: war.getAttribute('data-handle'),
        warrantyMonths: parseInt(war.getAttribute('data-months'), 10),
        customerEmail: custEmail,
        customerId: custId
      };
      fetch(WORKER, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) { if (!r.ok) throw new Error('worker'); return r.json(); })
        .then(function (d) {
          var w = (d && d.warranty) || d;
          if (!w || !w.variantId) throw new Error('no variant');
          return addItems([{
            id: w.variantId,
            quantity: 1,
            properties: {
              'Número de serie': w.serial,
              'Duración': (w.warrantyMonths || payload.warrantyMonths) + ' meses',
              'Artículo protegido': payload.productTitle
            }
          }]);
        })
        .then(refresh)
        .catch(function () { busy(war, false); });
      return;
    }
  });
})();
